import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import VideoBriefLogo from "./VideoBriefLogo";
import "./Marketing.css";

const useCaseLinks = [
  ["Sales Enablement", "/sales-enablement"],
  ["Business Development", "/business-development"],
  ["Product Marketing", "/product-marketing"],
  ["Content Marketing", "/content-marketing"],
];

export function MarketingNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="vb-nav">
      <div className="vb-container vb-nav__inner">
        <Link to="/" className="vb-nav__brand" aria-label="VideoBrief.ai home">
          <VideoBriefLogo />
          <span className="vb-nav__tagline">Extract Intel. Ship Clips.</span>
        </Link>
        <nav className={`vb-nav__links ${open ? "is-open" : ""}`} aria-label="Primary navigation">
          <a href="/#workflow" onClick={() => setOpen(false)}>How it works</a>
          <a href="/#use-cases" onClick={() => setOpen(false)}>Use cases</a>
          <a href="/#demo" onClick={() => setOpen(false)}>Demo</a>
          <a href="/blog/">Insights</a>
          <a href="/login" className="vb-button vb-button--quiet">Sign in</a>
          <Link to="/register" className="vb-button vb-button--primary" onClick={() => setOpen(false)}>
            Try VideoBrief Free
          </Link>
        </nav>
        <button
          className="vb-nav__toggle"
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
}

export function MarketingFooter() {
  return (
    <footer className="vb-footer">
      <div className="vb-container vb-footer__grid">
        <div>
          <VideoBriefLogo variant="dark" />
          <p>Extract the signal in long-form video. Ship the moments that move GTM forward.</p>
        </div>
        <div>
          <strong>Use cases</strong>
          {useCaseLinks.map(([label, href]) => <Link key={href} to={href}>{label}</Link>)}
        </div>
        <div>
          <strong>Company</strong>
          <a href="/blog/">Insights</a>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-of-service">Terms</Link>
        </div>
        <div>
          <strong>Get started</strong>
          <Link to="/register">Try VideoBrief Free</Link>
          <a href="/login">Sign in</a>
        </div>
      </div>
      <div className="vb-container vb-footer__base">© 2026 VideoBrief.ai · All rights reserved</div>
    </footer>
  );
}

export function ProductFrame({ src, alt, label, className = "", eager = false }) {
  return (
    <figure className={`vb-product-frame ${className}`}>
      <div className="vb-product-frame__bar">
        <span />
        <span />
        <span />
        <strong>{label}</strong>
      </div>
      <img
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
      />
    </figure>
  );
}

export function FinalCta({ title = "Your best video is already recorded." }) {
  return (
    <section className="vb-final-cta">
      <div className="vb-container">
        <span className="vb-eyebrow vb-eyebrow--light">EXTRACT THE VALUE</span>
        <h2>{title}</h2>
        <p>Find the insight. Create the clip. Give your GTM team something it can use.</p>
        <div className="vb-actions vb-actions--center">
          <Link to="/register" className="vb-button vb-button--light">Try VideoBrief Free</Link>
          <a href="/#demo" className="vb-button vb-button--outline-light">See It in Action</a>
        </div>
        <small>No credit card required.</small>
      </div>
    </section>
  );
}

export default function MarketingShell({ children }) {
  return (
    <div className="vb-marketing">
      <MarketingNav />
      <main>{children}</main>
      <MarketingFooter />
    </div>
  );
}
